import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5be6145a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-body pt-11 pt-md-9 pb-11 pb-md-9 position-relative" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap" }
const _hoisted_4 = { class: "flex-grow-1" }
const _hoisted_5 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_6 = { class: "d-flex flex-column" }
const _hoisted_7 = { class: "d-flex flex-wrap align-items-center break-all mb-2" }
const _hoisted_8 = { class: "text-gray-900 fs-2 fw-bolder text-uppercase" }
const _hoisted_9 = { class: "text-gray-900 fs-2 fw-bold" }
const _hoisted_10 = { class: "text-gray-900 fs-2 fw-light" }
const _hoisted_11 = { class: "text-gray-900 fs-2 fw-light" }
const _hoisted_12 = { class: "d-flex align-items-center flex-wrap text-gray-400 fw-semibold fs-6 mb-4 pe-2" }
const _hoisted_13 = { class: "mb-4" }
const _hoisted_14 = { class: "d-flex align-items-center" }
const _hoisted_15 = { class: "fs-4 fw-bold" }
const _hoisted_16 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_17 = { class: "d-flex align-items-center" }
const _hoisted_18 = { class: "fs-4 fw-bold" }
const _hoisted_19 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_20 = { class: "d-flex flex-wrap flex-start" }
const _hoisted_21 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-4 mb-3" }
const _hoisted_22 = { class: "d-flex align-items-center" }
const _hoisted_23 = { class: "fs-4 fw-bold" }
const _hoisted_24 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_25 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_26 = { class: "d-flex align-items-center" }
const _hoisted_27 = { class: "fs-4 fw-bold" }
const _hoisted_28 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_29 = { class: "card mb-5 mb-xl-10" }
const _hoisted_30 = { class: "card-title align-items-start flex-column my-8" }
const _hoisted_31 = { class: "py-6 px-9" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = { class: "svg-icon svg-icon-3 svg-icon-primary me-2" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_window_resize = _resolveComponent("window-resize")!
  const _component_SingleSKUCard = _resolveComponent("SingleSKUCard")!
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_ButtonGrop = _resolveComponent("ButtonGrop")!
  const _component_ReportInvoiceException = _resolveComponent("ReportInvoiceException")!
  const _component_ReportProductException = _resolveComponent("ReportProductException")!
  const _component_SearchProducts = _resolveComponent("SearchProducts")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.t("dsSkuManagement.packageNumber")) + " :  ", 1),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.detailsData?.package_number), 1),
                  _createElementVNode("span", _hoisted_10, "  / " + _toDisplayString(_ctx.t("dsSkuManagement.orderID")) + " :  ", 1),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.detailsData?.order_id), 1),
                  _createElementVNode("span", {
                    class: _normalizeClass(["badge ms-4", _ctx.dsSkuStatusClass(_ctx.detailsData?.status as number)])
                  }, _toDisplayString(_ctx.t(`dsSkuManagement.${_ctx.dsSkuStatusText(_ctx.detailsData?.status as number)}`)), 3)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.t("dsSkuManagement.merchantName")) + ":  ", 1),
                    _createElementVNode("span", {
                      class: _normalizeClass(["text-gray-900 fw-bolder", { 'd-block': _ctx.isMobile, 'mx-1': !_ctx.isMobile }])
                    }, _toDisplayString(_ctx.detailsData?.merchant_name), 3)
                  ])
                ])
              ])
            ]),
            _createVNode(_component_window_resize, null, {
              sm: _withCtx(() => [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.formatDate(_ctx.detailsData?.created_at as string)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.t("dsSkuManagement.createdAt")), 1)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.formatDate(_ctx.detailsData?.updated_at as string)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.t("dsSkuManagement.updatedAt")), 1)
                ])
              ]),
              lg: _withCtx(() => [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.formatDate(_ctx.detailsData?.created_at as string)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.t("dsSkuManagement.createdAt")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.formatDate(_ctx.detailsData?.updated_at as string)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.t("dsSkuManagement.updatedAt")), 1)
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])), [
      [_directive_loading, _ctx.detailsLoading]
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_29, [
      _createElementVNode("div", {
        class: _normalizeClass(["card-header flex-max-sm-column max-sm-align-items-start align-items-center", {
          'border-bottom-0': _ctx.isMobile,
        }])
      }, [
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.t("dsSkuManagement.skuManagement")), 1)
        ])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["card-body", {
          'p-0': _ctx.isMobile,
        }])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData, (item, index) => {
          return _withDirectives((_openBlock(), _createBlock(_component_SingleSKUCard, {
            key: 
            _ctx.md5(
              `${item.item_id}
              ${item.item_exception}
              ${item.is_exception}
              ${item.sku_invoice_exception}
              ${JSON.stringify(item.attachment_items)}
              ${JSON.stringify(_ctx.options)},
              ${_ctx.refushAllCardFlag}
              ${_ctx.refushSingleCardFlag[index]}`
            )
          ,
            id: `single-SKU-card-${index + 1}`,
            itemData: item,
            options: _ctx.options,
            status: _ctx.status,
            valid: _ctx.itemValid[index],
            onReportButtonClick: _ctx.exceptionProductDataChange,
            onSearchButtonClick: _ctx.searchDataChange,
            onFormDataChange: _ctx.formDataChange,
            onPass: ($event: any) => (_ctx.itemPass(index)),
            onNoPass: ($event: any) => (_ctx.itemNoPass(index))
          }, null, 8, ["id", "itemData", "options", "status", "valid", "onReportButtonClick", "onSearchButtonClick", "onFormDataChange", "onPass", "onNoPass"])), [
            [_directive_loading, _ctx.SKUCardLoading[index]]
          ])
        }), 128))
      ], 2)
    ])), [
      [_directive_loading, _ctx.mainCardLoading]
    ]),
    _createElementVNode("div", _hoisted_31, [
      _createElementVNode("div", {
        class: _normalizeClass(["header position-fixed bottom-0 start-0 end-0 d-flex justify-content-between px-9 py-3 bg-white content-fixed-bottom", {
          'flex-column': _ctx.isMobile,
          'gap-2': _ctx.isMobile,
        }])
      }, [
        (_ctx.hasNewInvoice())
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["text-primary d-flex align-items-center invoice-tip", {
            'ms-12': !_ctx.isMobile,
          }]),
              "data-bs-toggle": "modal",
              "data-bs-target": "#modal_report_invoice_exception",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.exceptionInvoiceDataChange && _ctx.exceptionInvoiceDataChange(...args))),
              disabled: 
            _ctx.reportInvoiceButtonLoading ||
            _ctx.detailsLoading ||
            _ctx.mainCardLoading ||
            _ctx.hasSKUCardLoading()
          
            }, [
              _createElementVNode("span", _hoisted_33, [
                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen044.svg" })
              ]),
              _createElementVNode("span", null, _toDisplayString(_ctx.t("dsSkuManagement.invoiceHasUpdated")), 1)
            ], 10, _hoisted_32))
          : _createCommentVNode("", true),
        _hoisted_34,
        _createVNode(_component_ButtonGrop, {
          downloadButtonLoading: _ctx.downloadButtonLoading,
          onDownloadButtonClick: _ctx.downloadSkuImages,
          saveButtonLoading: _ctx.saveButtonLoading,
          saveButtonDisabled: !_ctx.hasChange,
          onSaveButtonClick: _ctx.saveMultipleSKU,
          reportButtonLoading: _ctx.reportInvoiceButtonLoading,
          onReportButtonClick: _ctx.exceptionInvoiceDataChange,
          publishButtonLoading: _ctx.publishButtonLoading,
          onPublishButtonClick: _ctx.publishAllSKU,
          allButtonDisabled: 
            _ctx.detailsLoading || _ctx.mainCardLoading || _ctx.hasSKUCardLoading()
          
        }, null, 8, ["downloadButtonLoading", "onDownloadButtonClick", "saveButtonLoading", "saveButtonDisabled", "onSaveButtonClick", "reportButtonLoading", "onReportButtonClick", "publishButtonLoading", "onPublishButtonClick", "allButtonDisabled"])
      ], 2)
    ]),
    _createVNode(_component_ReportInvoiceException, {
      exceptionData: _ctx.exceptionInvoiceParams,
      onExit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.reportInvoiceButtonLoadingChange(false))),
      onSubmit: _ctx.refushAllData
    }, null, 8, ["exceptionData", "onSubmit"]),
    _createVNode(_component_ReportProductException, {
      exceptionData: _ctx.exceptionProductParams,
      onSubmit: _cache[2] || (_cache[2] = ($event: any) => (_ctx.refushItemExceptionData(_ctx.exceptionProductParams.item_id)))
    }, null, 8, ["exceptionData"]),
    _createVNode(_component_SearchProducts, {
      searchParams: _ctx.searchParams,
      options: _ctx.options,
      onSubmit: _ctx.chooseProduct
    }, null, 8, ["searchParams", "options", "onSubmit"])
  ]))
}